import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mto_section_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  mto_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  image_guid: fromDatatype.GuidDataFieldInterface;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  section_code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  is_compulsory: boolean;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_fi_mto_section_hdr_RowClass implements bl_fi_mto_section_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  mto_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  image_guid: fromDatatype.GuidDataFieldInterface;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  section_code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  is_compulsory: boolean;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
}
